import { useTranslation } from 'react-i18next'
import './title-modal.component.scoped.scss'

interface Props {
  stepPage?: number
  maxStep?: number
}

export default ({ stepPage, maxStep }: Props) => {
  const { t } = useTranslation('modalVinculateSocialNetwork')

  return <h6 className="title m-0">{t('newTutorialInstagram.title', { stepPage, maxStep })}</h6>
}
